<template>
    <el-dialog
        title="选择试卷"
        :visible.sync="visible"
        width="8rem"
        class="step-audit-dialog"
        key="exam3Dialog"
        :before-close="handleExam3DialogClose">
        <el-form :model="form" :inline="true" label-width="100px" key="3" class="user-step-search-form">
            <el-form-item label="试卷名称：" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="" class="search-itrm-btn">
                <el-button size="mini" @click="handleExam3DialogSearch">查询</el-button>
                <el-button size="mini" class="reset-btn" @click="handleExam3DialogReset">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="training-step-table">
            <el-table :data="tableForm.formResult.list" style="width: 100%" key="exam3table">
                <el-table-column key="exam3col1" type="index" label="序号"></el-table-column>
                <el-table-column key="exam3col2" prop="title" show-overflow-tooltip label="试卷名称" width="168"></el-table-column>
                <el-table-column key="exam3col3" prop="orgName" label="发布单位"></el-table-column>
                <el-table-column key="exam3col4" prop="createTime" label="发布时间" width="168"></el-table-column>
                <el-table-column key="exam3col5" prop="creatorName" label="发布人账号" width="100"></el-table-column>
                <el-table-column key="exam3col6" prop="status" label="发布状态">
                    <template slot-scope="scope">
                        <span>已发布</span>
                    </template>
                </el-table-column>
                <el-table-column key="exam3col7" prop="action" label="操作" width="80">
                    <template slot-scope="scope">
                        <div class="table-btn table-btn-view" @click="chooseExamItem(scope.row)">
                            <span>选择</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <pagination key="exam3page" @request-form-list="queryPaperList" :form="tableForm"></pagination>
        </div>
        <div class="dialog-footer">
            <el-button type="primary" size="mini" @click="handleExam3DialogClose">取消</el-button>
            <!-- <el-button type="primary" size="mini" @click="handleExam3DialogClose">确认</el-button> -->
        </div>
    </el-dialog>
</template>
<script>
import pagination from '@/components/pagination/index'
export default {
    name: 'choosePaperDailog',
    props: ['visible'],
    components: { pagination },
    data() {
        return {
            form: {title: '' },
            tableForm: {
                formResult: { currentPage: 1, list: [], total: 0 },
                pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
            }
        }
    },
    methods: {
        handleExam3DialogClose() {
            this.$emit('closeDailog')
        },
        handleExam3DialogSearch() {
            this.tableForm.pageData.currentPage = 1
            this.queryPaperList()
        },
        handleExam3DialogReset() {
            this.form.title = ''
            this.handleExam3DialogSearch()
        },
        chooseExamItem(row) {
            console.log(row)
            this.queryExam3Detail(row.id)
        },
         // 加载考试
        queryPaperList() {
            this.$api.user.exam.trainExamList({
                formData: { title: this.form.title, isPublish: 1},
                pageData: this.tableForm.pageData
            }).then(res => {
                this.tableForm.formResult = res.data
            })
        },
        // 加载考试详情
        queryExam3Detail(id) {
            this.$api.user.exam.paperDetail({
                id: id
            }).then(res => {
                this.$emit('confirmDailog', res.data)
            })
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.handleExam3DialogReset()
            }
        }
    }
}
</script>